import styled from "styled-components";

export const Title = styled.h2`
   font-size: 36px;
   font-weight: 700;
   line-height: 50px;
   text-align: center;
   color: #2A2637;
   margin-bottom: 48px;
   @media(max-width: 600px) {
     text-align: left;
     width: 200px;
     line-height: 33px;
     margin-bottom: 36px;
  }
`

export const Container = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-bottom: 32px;
   @media(max-width: 600px) {
     align-items: flex-start ;
   }
   @media(max-width: 1100px) {
     padding: 0 15px;
   }
`

export const Content = styled.div`
   display: flex;
   margin-bottom: 100px;
   @media(max-width: 970px) {
     flex-wrap: wrap-reverse;
     width: 100%;
     align-items: flex-start;
   }
   @media(max-width: 480px) {
     margin-bottom: 56px;
  }
`

export const ImageMobile = styled.img`
  height: 370px;
  @media(max-width: 480px) {
    width: 300px;
    height: 248px;
    text-align: center;
  }
`

export const Image = styled.img`
  height: 376px;
  @media(max-width: 480px) {
    width: 300px;
    height: 282px;
    text-align: center;
  }
`

export const ContentBlock = styled.div`
   display: flex;
   margin-bottom: 100px;
   @media(max-width: 970px) {
     flex-wrap: wrap;
     width: 100%;
     align-items: flex-start ;
   }
`

export const IndentAdmin = styled.div`
   width: 60px;
   @media(max-width: 970px) {
     width: 0px;
   }
`
